import React from 'react';
import block from 'bem-cn';
import './Switcher.scss';

const b = block('switcher');

const Switcher = ({ isActive, onSwitch, isMobile }) => {
  return (
    <div
      className={b({ active: isActive })}
      onClick={() => {
        onSwitch(ps => !ps);
      }}>
      <div className={b('indicator')} />
    </div>
  );
};

export default Switcher;
